import Vue from 'vue'
import Vuex from 'vuex'
import database from 'database'
import AuthSubscriptionsPlugin from './plugins/AuthSubscriptionsPlugin'
import SessionSubscriptionsPlugin from './plugins/SessionSubscriptionsPlugin'
import i18nSubscriptionsPlugin from './plugins/i18nSubscriptionsPlugin'
import uiSubscriptionsPlugin from './plugins/uiSubscriptionsPlugin'
import themesSubscriptionsPlugin from './plugins/themesSubscriptionsPlugin'
import menuSubscriptionsPlugin from './plugins/menuSubscriptionsPlugin'

Vue.use(Vuex)

const modules = {
  i18n: require('./modules/i18n').default,
  auth: require('./modules/auth').default,
  session: require('./modules/session').default,
  ui: require('./modules/ui').default,
  themes: require('./modules/themes').default,
  menu: require('./modules/menu').default
}

const store = new Vuex.Store({
  strict: process.env.NODE_ENV === 'development',

  modules,

  actions: {
    reset ({ dispatch }) {
      dispatch('auth/reset')
      dispatch('session/reset')
      dispatch('i18n/reset')
    }
  },

  plugins: [
    AuthSubscriptionsPlugin,
    SessionSubscriptionsPlugin,
    i18nSubscriptionsPlugin,
    uiSubscriptionsPlugin,
    themesSubscriptionsPlugin,
    menuSubscriptionsPlugin
  ]
})

const initializeModulesReadyHook = (modules, store) => {
  _.forEach(modules, module => {
    if ('ready' in module) {
      module.ready(store)
    }

    if ('modules' in module) {
      initializeModulesReadyHook(module.modules, store)
    }
  })
}

export const bootstrap = async () => {
  initializeModulesReadyHook(modules, store)

  const authData = await database.User.toCollection().first()
  const userSession = await database.UserSession.toCollection().first()
  const settingsData = await database.Settings.toCollection().first()

  if (authData) {
    const current = userSession.current
    store.dispatch('auth/setToken', authData.token)
    store.dispatch('auth/setUser', authData.user)
    store.dispatch('session/setSession', {
      company: userSession.company,
      ambito: userSession.ambito,
      current: { isImpersonate: current.isImpersonate, company: { id: current.company.id, name: current.company.name } }
    })
  }

  if (settingsData) {
    const { locale } = settingsData
    const { sidebarClosed } = settingsData
    const { themes } = settingsData
    const { menu } = settingsData

    if (locale) {
      store.dispatch('i18n/setLocale', locale)
    }
    if (sidebarClosed) {
      store.dispatch('ui/toggleSidebar', sidebarClosed)
    }
    if (themes) {
      store.dispatch('themes/switchTheme', themes)
    }
    if (menu) {
      store.dispatch('menu/changeSideMenuStatus', menu)
    }
  }
}

export default store
